import {ReactNode} from "react";
import classNames from "classnames";
import {Svg} from "@/shared/ui/Svg";
import styles from "./Chip.module.scss";

type Variant = "primary" | "secondary";

type Size = "s" | "m" | "l" | "xl" | "xxl";

type Props = {
    variant?: Variant;
    size?: Size;
    children: ReactNode;
    className?: string;
    onRemove?: () => void;
};

export const Chip = ({variant = "primary", size = "l", children, className, onRemove}: Props) => {
    return (
        <div className={classNames(styles.chip, styles[variant], styles[size], className)}>
            <span className={styles.label}>{children}</span>
            {onRemove && (
                <button
                    type={`button`}
                    className={styles.removeButton}
                    onClick={onRemove}
                    aria-label={`Удалить`}
                >
                    <Svg id={`cross`} className={styles.cross} />
                </button>
            )}
        </div>
    );
}
